import ProjectMilestoneCoordinationPage from "../../shared/project-milestone-coordination/ProjectMilestoneCoordinationPage";

const SolarentOperatorProjectMilestoneCoordinationPage = () => (
  <ProjectMilestoneCoordinationPage source="SolarentOperator" />
);

export default SolarentOperatorProjectMilestoneCoordinationPage;
